// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"pageHeader__Q7yzL","leftBlock":"leftBlock__LofSD","subTitle":"subTitle__dLTWx","title":"title__6dlFe","separator":"separator__jaxhg","rightBlock":"rightBlock__THK9y"};